import { FC } from 'react';
import { Box, useThemeValue, AnimatedShape } from '@altermaind/web/ui';
import { convertSizeToNumber } from '@/_shared/helpers/convertSizeToNumber';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

export const StartQuizHeaderSkeleton: FC = () => {
  const { genericResponsiveValue } = useResponsiveStyle();
  const gapM = convertSizeToNumber(`${useThemeValue('sizes', 'm')}`);

  return (
    <Box
      display='flex'
      mx='l'
      flexDirection='column'
      px='s'
      width='100%'
      zIndex={99}
      justifyContent='flex-end'
      height='100%'
    >
      <Box
        mb={genericResponsiveValue({
          breakPoints: { desktop: 'l' },
          defaultValue: 'm',
        })}
        textAlign='left'
      >
        <AnimatedShape height={25} width='100%' variant='semiRound' mb='xxs' />
        <AnimatedShape height={25} width='45%' variant='semiRound' mb='s' />
      </Box>
      <Box
        display='flex'
        flexWrap='wrap'
        justifyContent={genericResponsiveValue({
          breakPoints: { desktop: 'center' },
          defaultValue: 'left',
        })}
        alignItems='stretch'
        style={{ gap: gapM }}
        marginRight={genericResponsiveValue({
          breakPoints: { mobile: '0' },
          defaultValue: 'auto',
        })}
        mb='l'
      >
        {/* DURATION */}
        <Box
          display='flex'
          flexDirection='row'
          alignItems={genericResponsiveValue({
            breakPoints: { desktop: 'center' },
            defaultValue: 'left',
          })}
        >
          <AnimatedShape size='xs' variant='semiRound' />
          <AnimatedShape height={15} width={50} variant='semiRound' />
        </Box>
        {/* QUESTIONS */}
        <Box
          display='flex'
          flexDirection='row'
          alignItems={genericResponsiveValue({
            breakPoints: { desktop: 'center' },
            defaultValue: 'left',
          })}
        >
          <AnimatedShape size='xs' variant='semiRound' />
          <AnimatedShape height={15} width={50} variant='semiRound' />
        </Box>
        {/* RATING (se presenti) */}
        <Box
          display='flex'
          flexDirection='row'
          alignItems={genericResponsiveValue({
            breakPoints: { desktop: 'center' },
            defaultValue: 'left',
          })}
        >
          <AnimatedShape size='xs' variant='semiRound' />
          <AnimatedShape height={15} width={30} variant='semiRound' />
        </Box>
        {/* CREDITS (se presenti) */}
        <Box
          display='flex'
          flexDirection='row'
          alignItems={genericResponsiveValue({
            breakPoints: { desktop: 'center' },
            defaultValue: 'left',
          })}
        >
          <AnimatedShape size='xs' variant='semiRound' />
          <AnimatedShape height={15} width={50} variant='semiRound' />
        </Box>
      </Box>
    </Box>
  );
};
